'use client'

import type { SelectItemPayload } from 'analytics/events/eec/selectItem/selectItem'
import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import React, { cloneElement } from 'react'

import { useAnalytics } from '../../contexts/AnalyticsProvider/AnalyticsProvider'

type EventElementProps = {
	children: React.ReactElement
	selectItemPayload: SelectItemPayload
}

export const AnalyticSelectItem = ({
	children,
	selectItemPayload,
}: EventElementProps): React.ReactNode => {
	const { sendSelectItem } = useEECEvents()
	const { sendChangeColorEvent } = useAnalytics()

	const sendAnalyticEvents = () => {
		sendSelectItem(selectItemPayload)
		sendChangeColorEvent()
	}

	return cloneElement(children, {
		onClick: sendAnalyticEvents,
	})
}
